import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { api } from "../lib/api";
import { formatDate } from "../lib/format";

export default function Trash() {
  const [items, setItems] = useState([]);
  const load = () => api.listTrash().then(setItems).catch(() => toast.error("Errore"));
  useEffect(() => { load(); }, []);
  const restore = async (id) => {
    try { await api.restoreTask(id); toast.success("Ripristinato"); load(); }
    catch { toast.error("Errore"); }
  };

  return (
    <div className="space-y-6" data-testid="trash-page">
      <div>
        <div className="text-xs font-mono uppercase tracking-widest opacity-70">Cestino</div>
        <h1 className="mt-1 font-display text-3xl sm:text-4xl font-semibold">Cestino</h1>
        <p className="mt-2 text-sm opacity-80 max-w-2xl">Gli elementi eliminati vengono conservati 30 giorni, poi rimossi definitivamente.</p>
      </div>
      {items.length === 0 ? (
        <div className="pxos-card p-10 text-center opacity-70" data-testid="trash-empty">Il cestino è vuoto.</div>
      ) : (
        <div className="pxos-card divide-y" style={{ borderColor: "var(--pxos-border)" }}>
          {items.map((t) => (
            <div key={t.id} className="p-3 flex items-center gap-3" data-testid="trash-row">
              <div className="flex-1 min-w-0">
                <div className="font-medium truncate">{t.title}</div>
                <div className="text-xs opacity-70">Eliminato il {formatDate(t.deleted_at)}</div>
              </div>
              <button onClick={() => restore(t.id)} className="text-sm inline-flex items-center gap-1 rounded-full border px-3 py-1.5" data-testid="trash-restore-btn">
                <RotateCcw size={14}/> Ripristina
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
